import Vue from 'vue';

// We are using vue-svgicon to generate icons as components  - https://github.com/MMF-FE/vue-svgicon
import SvgIcon from 'vue-svgicon';
import '@/components/icons';

// Default tag name is 'svgicon'
Vue.use(SvgIcon, {
    tagName: 't-icon',
    classPrefix: 't-icon',
    defaultWidth: '1em',
    defaultHeight: '1em'
});
